export const TRANSPORTATION_TYPES = {
  ROAD: "Autotransport",
  RAILWAY: "Railtransport",
};

export const RAILWAY_ORDERS_PATH = "/orders/railway";
export const RAILWAY_EXPEDITOR_ORDERS_PATH = "/orders/railway/available";
export const MAX_RAILWAY_WAGONS_COUNT = 2000;

export const isRailwayOrder = (order) => order?.transportationType === TRANSPORTATION_TYPES.RAILWAY;

export const getOrderWagonNumbers = (order) =>
  Array.isArray(order?.wagonNumbers)
    ? order.wagonNumbers
        .filter((number) => typeof number === "string" && number.trim())
        .map((number) => number.trim())
    : [];

export const getRailwayOrderPath = (mode, id) => `/orders/railway/${mode}/${id}`;
